import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    if (id) return `${window.api_url}/organization/subsidy_programs/${id}`;
    return `${window.api_url}/organization/subsidy_programs`;
  },

  create(subsidyProgram, success, failure) {
    if (!success)
      return axios.post(this.baseUrl(), { subsidy_program: subsidyProgram }).catch(handleError);
    axios.post(this.baseUrl(), { subsidy_program: subsidyProgram }).then(success).catch(failure);
  },

  destroy(subsidyProgramId) {
    return axios.delete(this.baseUrl(subsidyProgramId)).catch(handleError);
  },

  get(subsidyProgramId, success) {
    if (!success) return axios.get(this.baseUrl(subsidyProgramId)).catch(handleError);
    return axios.get(this.baseUrl(subsidyProgramId)).then(success).catch(handleError);
  },

  index(params = {}) {
    return axios.get(this.baseUrl(), { params }).catch(handleError);
  },

  update(id, subsidyProgram, success, failure) {
    if (!success)
      return axios.patch(this.baseUrl(id), { subsidy_program: subsidyProgram }).catch(handleError);
    axios.patch(this.baseUrl(id), { subsidy_program: subsidyProgram }).then(success).catch(failure);
  },

  deferred_acceptance: {
    baseUrl(subsidyProgramId) {
      return `${window.api_url}/organization/subsidy_programs/${subsidyProgramId}/deferred_acceptance`;
    },

    create(subsidyProgramId, params) {
      return axios.post(this.baseUrl(subsidyProgramId), params).catch(handleError);
    },

    destroy(subsidyProgramId) {
      return axios.delete(this.baseUrl(subsidyProgramId)).catch(handleError);
    },

    get(subsidyProgramId) {
      return axios.get(this.baseUrl(subsidyProgramId)).catch(handleError);
    },

    downloadDebugYamlUrl(subsidyProgramId, id) {
      return `${this.baseUrl(subsidyProgramId)}/download_run_summary?id=${id}`;
    },
  },

  enrollment: {
    baseUrl(id) {
      return `${window.api_url}/organization/subsidy_programs/${id}/enrollments`;
    },

    bulkUpdate(subsidyProgramId, params) {
      return axios.patch(this.baseUrl(subsidyProgramId), params).catch(handleError);
    },
  },

  seatSync: {
    baseUrl(subsidyProgramId) {
      return `${window.api_url}/organization/subsidy_programs/${subsidyProgramId}/seat_syncs`;
    },

    create(params, subsidyProgramId) {
      return axios.post(this.baseUrl(subsidyProgramId), { seat_sync: params }).catch(handleError);
    },

    get(id, subsidyProgramId) {
      return axios.get(`${this.baseUrl(subsidyProgramId)}/${id}`).catch(handleError);
    },

    index(subsidyProgramId) {
      return axios.get(this.baseUrl(subsidyProgramId)).catch(handleError);
    },

    run(id, subsidyProgramId) {
      return axios.patch(`${this.baseUrl(subsidyProgramId)}/${id}/run`).catch(handleError);
    },
  },

  subsidyApplicationReevaluation: {
    baseUrl(subsidyProgramId) {
      return `${window.api_url}/organization/subsidy_programs/${subsidyProgramId}/subsidy_application_reevaluation`;
    },

    create(subsidyProgramId) {
      return axios.post(this.baseUrl(subsidyProgramId)).catch(handleError);
    },
  },

  upload: {
    baseUrl(id) {
      return `${window.api_url}/organization/subsidy_programs/${id}/uploads`;
    },

    create(id, upload) {
      return axios.post(this.baseUrl(id), { upload }).catch(handleError);
    },
  },
};
